export default {
	result: {
		err: 'Order information error.',
		success: 'Pay Success',
		paymoney: 'Money:',
		yuan: ' yuan',
		order: {
			describe: 'Payment Information',
			name: 'Merchant Name:',
			no: 'Order No:',
			paytime: 'Payment time:'
		},
		detail: {
			describe: 'Detail Information',
			project: 'Charge Items:',
			range: 'Toll Interval:',
			money: 'Amount:',
			remark: 'remark info'
		},
		ticket: {
			describe: 'Invoice Information',
			title: 'Invoice Title:',
			type: 'Invoice Type:',
			idtype: 'Taxpayer Identification Number:',
			email: 'Mailbox:'
		}
	},
	router: {
		pay: {
			unpaid_fee: 'To Be Paid',
			choose_fee: 'Optional Payments',
			self_service: {
				title: 'Self Service',
				pay_situation: 'Fee Records',
				pay_record: 'Pay Records'
			}
		},
		confirm: {
			pay_ticket: 'Payment Confirmation',
			pay_confirm: 'Waiting for Payment'
		},
		anonymous: {
			anonymous_pay: 'Anonymous Payments'
		}
	},
	home: {
		homepage: 'home page',
		title: 'payment portal',
		welcome_text: 'welcome'
	},
	unpaid_fee: {
		emptyText: 'No Data',
		loading: 'loading...',
		charge_card: {
			range: 'Fee Range',
			standard: 'Fee Standards',
			count: 'Count',
			receive: 'Current Payable',
			pay: 'Amount of Payment'
		},
		selectAll: 'Select all',
		sumOfMoney: 'Total',
		pay: 'To Pay',
		cancel_success: 'Cancel Origin Order Success'
	},
	pay_ticket: {
		ticket_info: 'Invoice Information',
		ticket_detail: 'Order Details',
		code: 'Student ID',
		name: 'Name',
		name_placeholder: 'Input the name',
		bussiness_code: 'Certificate Number',
		fee_remark: 'Fee Remark',
		ticket_remark: 'Fill the invoice notes',
		collapse_ticket_remark: 'Fold the invoice notes',
		ticket_notify: 'Invoice Notify',
		email: 'email',
		email_placeholder: 'Input the email address.',
		sum: 'Total',
		commit: 'Submit',
		pay: 'To Pay',
		add: 'Add',
		reset: 'Reset',
		cancel: 'Cancel',
		search: 'Search',
		person_title: 'Personal',
		company_title: 'Organization',
		person: 'Issue Personal Invoice',
		person_tips: 'Part of the fee items can only be invoiced with personal invoice title.',
		person_placeholder: 'Input the invoice title.',
		organ: 'Issue Enterprise and Organization Invoice',
		organ_placeholder: 'Input the key word of organization',
		add_tips: 'No invoice title is currently selected. Please query and select an invoice title of organization, or ',
		add_ticket: 'add a new one.',
		add_organ: 'Add New Invoice Title of Organization',
		select_organ: 'Choose Invoice Title of Organization',
		close: 'Close',
		check: 'Select',
		emptyText: 'No Data',
		pre_page: 'previous page',
		tips: 'Please input the key word for searching organization.',
		confirm_add_title: 'No qualified organizations have been inquired about.Do you add a header?',
		title_not_sysu: '中山大学 is prohibited for invoice title',
		tax_number_not_sysu: 'the tax number of organization is prohibited for 中山大学',
		estate_date: 'Lease Date',
		estate_date_placeholder: 'Choose the lease date',
		estate_date_needed: 'Real estate rental fees require entering the lease date!',
		estate_addr_lost:
			'Address information has not been set for real estate rental fees. Please contact the teacher in charge of the charging fee.',
		organ_model: {
			view_detail: 'view detail',
			fold_detail: 'fold detail',
			name: 'Name',
			taxNumber: 'Tax Number',
			taxNumber_placeholder: 'Input the tax number',
			address: 'Address',
			address_placeholder: 'Input the address',
			tele: 'Telephone',
			tele_placeholder: 'Input the telephone number',
			depositBank: 'Bank of Deposit',
			depositBank_placeholder: 'Input the bank of deposit',
			bank: 'Bank Account',
			bank_placeholder: 'Input the bank account',
			name_rule: 'Please fill in the text box with name of organization.',
			taxNumber_rule: 'Please fill in the text box with tax number of organization.'
		},
		open_immediately: 'Directly',
		open_later: 'Later'
	},
	pay_confirm: {
		tips: 'Tips',
		tips_content: 'There is an unpaid order. Do you want to cancel or continue?',
		cancel_order: 'cancel order',
		continue_order: 'continue',
		pay_finish: 'Payment completed.',
		pay_fail: 'Failure to pay',
		pay_canceled: 'Payment cancelled ',
		pay_change: 'Payment not completed, change the payment method.',
		pay_error: 'Problems encountered during payment.',
		pay_cancel: 'Cancel the payment order',
		pay_error_title: 'Problems arise when payment is made',
		pay_error_tips: `Please record the following information and contact the toll teacher for processing.`,
		pay_error_tips2: `If your account's money is not deducted, you can cancel the order and make a new payment.`,
		close: 'Close',
		cancel_repay: 'Cancel the order and pay again.',
		timeout_tip: 'The order has expired. Please refresh the page and resubmit the order.',
		state: {
			confirm: 'OK',
			fresh: 'Refresh order'
		}
	},
	qrcode_page: {
		range: 'Fee Range',
		standard: 'Standard Name',
		count: 'Count',
		pay_money: 'Money',
		price: 'Price',
		pay_money_placeholder: 'Input the amount of payment',
		fee_remark: 'Fee Remark',
		fee_remark_fold: 'Fold Fee Remark',
		fee_remark_placeholder: 'Input the fee remark'
	},
	pay_situation: {
		all: 'All',
		no_range_year: 'No Year for Range',
		choose_year: 'Choose Range Year',
		cancel_text: 'Cancel',
		confirm_text: 'Confirm',
		emptyText: 'No Data',
		pre_page: 'Previous Page',
		loading: 'loading...',
		download: {
			title: 'Download Invoice',
			name: 'Fee Item',
			money: 'Amount of Payment',
			date: 'Date of Payment',
			code: 'Invoice Number',
			download: 'Download Invoices',
			close: 'Close',
			tips: 'No downloadable invoices.'
		},
		list: {
			name: 'Fee Item',
			range: 'Range',
			need_money: 'Payables',
			later_money: 'Delay',
			receive_money: 'Actual Payment Amount',
			operate: 'Operation',
			detail: 'Details',
			download: 'Download Invoice',
			noRange: 'no year',
			allRange: 'all'
		}
	},
	pay_situation_detail: {
		sum_need_pay: 'Current Total Payables',
		sum_already_pay: 'Total Amount Paid',
		standard: 'Standard Payables',
		discount: 'Reduction',
		deduction: 'Deduction',
		laterVos: 'Delay',
		reditVos: 'Loan',
		payTikectVos: 'Paid',
		nowMoney: 'Current Payables',
		close: 'Close'
	},
	pay_record: {
		list: {
			code: 'Order Number',
			money: 'Amount',
			pay_type: 'Method of Payment',
			pay_date: 'Time of Payment',
			operate: 'Operation',
			detail: 'Details',
			starttime: 'Start Date',
			endtime: 'End Date',
			to: 'To',
			search: 'Search'
		},
		detail: {
			title: 'Payment Details',
			pay_info: 'Payment Information',
			pay_detail: 'Order Details',
			code: 'Order Number',
			status: 'Order Status',
			money: 'Amount',
			create_time: 'Create Time',
			pay_type: 'Method of Payment',
			pay_time: 'Payment Time',
			ticket_title: 'Invoice Title',
			send_to_email: 'Send to Email',
			email_title: 'Email',
			email_placeholder: 'Input the email address',
			confirm: 'Confirm',
			cancel: 'Cancel'
		}
	},
	choose_fee: {
		range: 'Range',
		price: 'Unit-Price',
		money: 'Amount',
		count: 'Quantity',
		maxMoneyMust: 'Please enter the amount',
		maxMoneyStart: 'Maximum:￥',
		maxMoneyEnd: '(CNY)',
		remark: 'Remarks',
		pay: 'Go To Pay',
		sum: 'Total Amount',
		default_range: 'Default Range'
	},
	pay_refund: {
		list: {
			project: 'Fee Item',
			range: 'Range',
			money: 'Amount of refund',
			type: 'Refund method',
			date: 'Date of refund',
			state: 'Refund status'
		}
	},
	message: {
		// 所有的提示信息
		ticketTitle: 'Please fill in the information of invoice title.'
	},

	success: {
		logout: {
			message: 'Are you sure you want to log out?',
			title: 'Logout',
			confirmButtonText: 'Logout',
			cancelButtonText: 'Cancel',
			successMessage: 'Successful logout.'
		}
	},
	error: {
		network: 'The server is busing, please try again later.',
		logout: {
			message: 'You have been logged out, you can click "Cancel" to stay on the page, or login again.',
			title: ' Confirm Logout ',
			confirmButtonText: 'Login again ',
			cancelButtonText: 'Cancel'
		},
		unknown: 'Unknown error, error code: {state}',
		400: 'Request error ',
		401: 'Unauthorised, please login ',
		403: 'Denied access ',
		404: 'Request address error: {url}',
		408: 'Request timeout ',
		500: 'Server internal error ',
		501: 'Service not implemented ',
		502: 'Gateway error ',
		503: 'Service unavailable ',
		504: 'Gateway timeout ',
		505: 'HTTP version is not supported ',
		6020101: 'User name or password error'
	}
}
